import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const config = z.object({
  payment: z.object({
    amountInCents: z.number().int().min(1),
    currency: z.string().length(3),
  }),
});

export class Config extends createZodDto(config) {}
